__webpack_require__.p = "/wp-content/plugins/cgi-api-plugin/dist/";